import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L7.93935 9.00001L3.96969 12.9697C3.6768 13.2626 3.6768 13.7374 3.96969 14.0303C4.26258 14.3232 4.73746 14.3232 5.03035 14.0303L9.00001 10.0607L12.9697 14.0303C13.2626 14.3232 13.7374 14.3232 14.0303 14.0303C14.3232 13.7374 14.3232 13.2626 14.0303 12.9697L10.0607 9.00001L14.0304 5.03033C14.3232 4.73744 14.3232 4.26256 14.0304 3.96967C13.7375 3.67678 13.2626 3.67678 12.9697 3.96967L9.00001 7.93935L5.03033 3.96967Z",
      fill: "#101C32"
    }, null, -1)
  ]))]))
}
export default { render: render }